// ENDPOINTS
export const GET_TYPOLOGIES = "/Typologies";
export const GET_TYPOLOGIES_BY_BER = "/MakeRecommendations/getTypologyByBer";
export const GET_TYPOLOGIES_BY_UPRN = "/MakeRecommendations/getTypologyByUprn";
export const GET_RECOMMENDATIONS = "/MakeRecommendations/getRecommendations";
export const APPLY_RECOMMENDATIONS = "/MakeRecommendations/applyRecommendations";
export const VALIDATE_KEY = "/Organisation/validateKey";
export const VALIDATE_MPRN = "/MakeRecommendations/validateMprn";
export const BER_RATING = "/BerRatings/stats"
export const QUOTE_RECOMMENDATIONS = "/MakeRecommendations/quoteRecommendations";
export const GET_QUOTED_RECOMMENDATIONS = "/MakeRecommendations/getQuotedRecommendations";
export const GET_RECOMMENDATIONS_FOR_FILE = "/MakeRecommendations/getRecommendationsForFile";
export const GET_GROUPED_RECOMMENDATIONS = "/MakeRecommendations/getGroupedRecommendations";
export const WRITE_LOG = "/log/write";
export const CREATE_PDF = "/PDF/create";

// EXCEPTIONS
export const EXCEPTION_NOT_EXIST = 'DoesNotExistException';
